var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 56,
    viewBox: "0 0 50 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2392 21.9104C47.5592 24.8304 48.2992 28.0804 48.2992 31.4904C48.2992 44.3604 37.8692 54.7904 24.9992 54.7904C12.1292 54.7904 1.69922 44.3604 1.69922 31.4904C1.69922 23.2704 5.95922 16.0504 12.3892 11.9004",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16.1104V54.7903",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.69922 31.5H48.2992",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39844 14.1904C12.0084 16.4004 17.0684 19.4705 25.1184 19.4705C25.9184 19.4705 26.6884 19.4404 27.4284 19.3804",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36719 48.7704C11.9472 46.4404 17.0072 43.1504 25.1172 43.1504C33.2272 43.1504 37.8472 46.2404 40.3972 48.5504",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1494 8.71973C21.2694 10.5897 12.1094 17.6197 12.1094 31.4997C12.1094 47.9697 25.0094 54.7997 25.0094 54.7997",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25 54.7898C25 54.7898 38.02 48.1498 38.02 31.4898V29.5898",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0184 0C32.4284 0 27.8984 4.52999 27.8984 10.12C27.8984 12.92 29.0385 15.46 30.8885 17.29L38.2184 26.36L45.5884 16.82C47.1684 15.04 48.1385 12.69 48.1385 10.12C48.1385 4.52999 43.6084 0 38.0184 0Z",
    fill: "#FFC000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4688 0.0195312V26.0295L45.5887 16.8195C47.1687 15.0395 48.1388 12.6895 48.1388 10.1195C48.1388 4.67954 43.8488 0.259531 38.4688 0.0195312Z",
    fill: "#0098C8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9799 7.19043C40.6599 7.76043 41.0999 8.61043 41.0999 9.57043C41.0999 11.2804 39.7198 12.6505 38.0198 12.6505C37.1698 12.6505 36.3998 12.3105 35.8398 11.7505",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.42bf66822af091e0babe48cf76e3dbe6.svg";
export { ForwardRef as ReactComponent };